import React from 'react';
import { connect } from 'react-redux';
import { navigate } from 'gatsby';
import Layout from '../Layout';
import LoadingIndicator from '../LoadingIndicator';
import { dataLayerPush } from '../../helpers/datalayer';
import { HOME_PAGE } from '../../constants/links.json';
import { ESIM_FLOW_ROUTES, PSIM_FLOW_ROUTES } from '../../constants/routes';
import { isEsim } from '../../helpers/userDetailsForm';

const steps = [
  { name: '1', value: 'one' },
  { name: '2', value: 'two' },
  { name: '3', value: 'three' },
  { name: '4', value: 'four' },
  { name: '5', value: 'five' }
];

const withLayout = (WrappedComponent, burgerSorry) => {
  const wrappedComp = class extends React.Component {
    componentDidMount() {
      if (window.lpTag && window.lpTag.newPage && this.props.location) {
        window.lpTag.newPage(this.props.location.href);
      }
    }

    render() {
      const isEsimSelected = isEsim(this.props.selectedSimType);
      const routes = isEsimSelected ? ESIM_FLOW_ROUTES : PSIM_FLOW_ROUTES;

      const stepList = steps.slice(0, routes.length);
      const currentStepIndex = routes.indexOf(this.props.location.pathname);

      const sendGTM = () =>
        dataLayerPush({
          event: 'live-chat',
          transaction: this.props.location.pathname
        });

      const onHeaderLogoClick = () => {
        navigate(HOME_PAGE.ABSOLUTE);
      };

      const enableHeaderLogoClick =
        ['/select-number/'].indexOf(this.props.location.pathname) > -1;

      return (
        <Layout
          currentStepIndex={currentStepIndex}
          stepList={stepList}
          hideBurger={
            ['/success/', '/delivery-details/'].indexOf(
              this.props.location.pathname
            ) > -1
          }
          sendGTM={sendGTM}
          burgerSorry={burgerSorry}
          onHeaderLogoClick={enableHeaderLogoClick ? onHeaderLogoClick : null}
        >
          <WrappedComponent {...this.props} />
          <LoadingIndicator
            requestNames={[
              'GET_DELIVERY_DATES',
              'RETRIEVE_ADDRESS',
              'SUBMIT_ORDER',
              'PORT_IN_NUMBER',
              'GET_POPSTATIONS',
              'GET_POPSTATIONS_BYPOSTCODE',
              'RETRIEVE_PROMO_CODE',
              'GET_ONE_TIME_CHARGE',
              'GET_APIGEE_TOKEN'
            ]}
          />
        </Layout>
      );
    }
  };

  const mapStateToProps = state => {
    return { selectedSimType: state.simTypeDetails.selectedSimType };
  };

  return connect(mapStateToProps)(wrappedComp);
};

export default withLayout;
